import { render, staticRenderFns } from "./TopWidgetTeamProfile.vue?vue&type=template&id=5ca935ae&"
import script from "./TopWidgetTeamProfile.vue?vue&type=script&lang=js&"
export * from "./TopWidgetTeamProfile.vue?vue&type=script&lang=js&"
import style0 from "./TopWidgetTeamProfile.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports